import React, {Component} from "react";
import {connect} from "react-redux";
import FJWatermarkCommonView from "../view/FJWatermarkCommonView";
import FJWatermarkAction from "../../../redux/action/FJWatermark.action";
import FJLocalStore from "../../../store/FJLocalStore";
import FJWatermarkFontContainer from './FJWatermarkFontContainer'
import FJTextAreaBox from '../view/FJTextAreaBox'

class FJWatermarkTextContainer extends Component {

  render() {

    const {
      isShow,
      watermarkSize,
      watermarkOpacity,
      setWatermarkParams,
      watermarkPosition,
      watermarkTextChange,
      watermarkText
    } = this.props;

    return (
      <div style={{display: isShow ? 'block' : 'none'}}>
        <FJTextAreaBox placeholder={FJLocalStore._('Input-watermark-text')}
                       onChange={watermarkTextChange}
                       value={watermarkText}/>
        <FJWatermarkFontContainer />
        <FJWatermarkCommonView watermarkSize={watermarkSize}
                               watermarkOpacity={watermarkOpacity}
                               setWatermarkParams={setWatermarkParams}
                               watermarkPosition={watermarkPosition}
        />
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    watermarkText: state.watermark.watermarkText,
    watermarkSize: state.watermark.watermarkSize,
    watermarkOpacity: state.watermark.watermarkOpacity,
    watermarkPosition: state.watermark.watermarkPosition
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    watermarkTextChange: function (type, value) {
      dispatch(FJWatermarkAction.watermarkTextChangeAction(type, value));
    },
    setWatermarkParams: function (type, data) {
      dispatch(FJWatermarkAction.setWatermarkParamsAction(type, data));
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FJWatermarkTextContainer);